/* global grecaptcha */

const MAX_SECONDS_TO_WAIT = 30

export function onRecaptchaAvailable(callback, expectedProperty = null) {
  if (typeof callback !== 'function') {
    return
  }

  if (typeof grecaptcha !== 'undefined' && (!expectedProperty || expectedProperty in grecaptcha)) {
    callback()
    return
  }

  const startedAt = Date.now()
  let timer = null

  timer = setInterval(() => {
    if (typeof grecaptcha === 'undefined' || (expectedProperty && !(expectedProperty in grecaptcha))) {
      if (Date.now() - startedAt >= MAX_SECONDS_TO_WAIT) {
        clearInterval(timer)
      }
      return
    }
    clearInterval(timer)
    callback()
  }, 250)
}

export function onRecaptchaV2Available(callback) {
  onRecaptchaAvailable(callback, 'render')
}

export function onRecaptchaV3Available(callback) {
  onRecaptchaAvailable(callback, 'execute')
}

export function setupRecaptchaV2(captchaEl) {
  onRecaptchaV2Available(() => {
    if (captchaEl.children.length > 0) {
      return
    }
    grecaptcha.render(captchaEl, {
      sitekey: captchaEl.getAttribute('data-sitekey'),
      theme: captchaEl.getAttribute('data-theme') || 'light',
      size: captchaEl.getAttribute('data-size') || 'normal',
    })
  })
}

export function initializeAndWatchRecaptchaV2(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.g-recaptcha')
  if (existingEls.length) {
    existingEls.forEach((el) => {
      setupRecaptchaV2(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('.g-recaptcha')
        if (!els.length) {
          return
        }

        els.forEach((el) => {
          setupRecaptchaV2(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}
